module.exports = __webpack_public_path__ + "static/media/member.dee54ede.svg";